import { render, staticRenderFns } from "./ProtocoloSelecionarBusca.vue?vue&type=template&id=65335a5c&scoped=true"
import script from "./ProtocoloSelecionarBusca.vue?vue&type=script&lang=js"
export * from "./ProtocoloSelecionarBusca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65335a5c",
  null
  
)

export default component.exports